import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { TriStateCheckbox } from "primereact/tristatecheckbox";

import {
  buttonRemove,
  labelDownload,
  labelSelect,
  labelSelectAll,
  labelShare,
  modalConfirmRemoveAllResponsesSubTitle,
  modalConfirmRemoveAllResponsesTitle,
  snackbarProjectLimitSharedMax,
  snackbarProjectLimitSharedMaxSubTitle,
  snackbarRemovedAnswersSubTitle,
  snackbarRemovedAnswersTitle,
} from "_constants";
import { useConfirmDialogExit } from "hooks";
import { PinAnswerRequest } from "interfaces";
import { useSnackbar } from "providers/SnackbarProvider";
import { downloadPinnedAnswers, pinAnswersResponse } from "services";
import {
  resetCheckIds,
  resetLoadedStatus,
  setAllToggle,
  setSelect,
} from "store/slicer/GestioneSaveAnswerSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { useState } from "react";
import { ModalShareAnswers } from "components/modals";
import { downloadFile } from "utils";

export const ActionsSaveResponseCard = ({
  projectId,
}: {
  projectId: string;
}) => {
  const dispatch = useAppDispatch();
  const { showConfirmDialogDelete } = useConfirmDialogExit();
  const [openModalShareResponse, setOpenModalShareResponse] =
    useState<any>(false);
  const { showSnackbar } = useSnackbar();
  const saveAnswer = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.saveAnswersFiltered
  );
  const checkIds = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.checkIds
  );
  const checkboxState: null | boolean = !checkIds.length
    ? null
    : checkIds.length === saveAnswer.length
    ? true
    : false;

  const handleCheckboxChange = () => {
    if (!checkboxState) {
      const request = saveAnswer.map((response: any) => response.id);
      dispatch(setAllToggle(request));
    } else {
      dispatch(resetCheckIds());
    }
  };

  const removeSelected = () => {
    showConfirmDialogDelete({
      title: modalConfirmRemoveAllResponsesTitle,
      subtitle: modalConfirmRemoveAllResponsesSubTitle,
      rejectCallback: confirmRemoveResponse,
    });
  };

  const confirmRemoveResponse = () => {
    const payload: PinAnswerRequest = {
      projectId: projectId,
      pin: false,
      answersIds: checkIds,
    };
    pinAnswersResponse(payload)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarRemovedAnswersTitle,
          detail: snackbarRemovedAnswersSubTitle,
          life: 5000,
        });
        dispatch(resetLoadedStatus());
        dispatch(resetCheckIds());
        dispatch(setSelect(false));
      })
      .catch((_) => {});
  };

  const downloadSelected = () => {
    downloadPinnedAnswers({ answersIdsList: checkIds, projectId: projectId })
      .then((response) => {
        downloadFile(response, 1);
      })
      .catch();
  };

  const sharedSelected = () => {
    if (checkIds.length > 10) {
      showSnackbar({
        severity: "info",
        summary: snackbarProjectLimitSharedMax,
        detail: snackbarProjectLimitSharedMaxSubTitle,
        life: 5000,
      });
    } else {
      setOpenModalShareResponse(true);
    }
  };

  return (
    <>
      <div className="d-grid col-3 align-center padd-top-14 padd-bottom-14">
        <div className="flex-container gap-9 align-center">
          <TriStateCheckbox
            onClick={(e) => e.stopPropagation()}
            value={checkboxState ?? false}
            onChange={handleCheckboxChange}
            uncheckIcon={!checkboxState ? PrimeIcons.MINUS : undefined}
          />
          <span className="text-regular-blue">{labelSelectAll}</span>
        </div>
        <div className="flex-container align-center">
          <Button
            label={buttonRemove}
            icon={PrimeIcons.BOOKMARK}
            onClick={removeSelected}
            iconPos="left"
            severity="danger"
            text
            disabled={!checkIds.length}
            className="box-shadow-none custom-button-bg"
          />
          <Button
            label={labelDownload}
            icon={PrimeIcons.DOWNLOAD}
            onClick={downloadSelected}
            iconPos="left"
            text
            disabled={!checkIds.length}
            className="box-shadow-none custom-button-bg"
          />
          <Button
            label={labelShare}
            icon={PrimeIcons.SHARE_ALT}
            onClick={() => sharedSelected()}
            iconPos="left"
            text
            disabled={!checkIds.length}
            className="box-shadow-none custom-button-bg"
          />
        </div>
        <div className="flex-container justify-end">
          <span className="text-base-regular">{labelSelect}</span>
          <span className="text-base-regular font-weight-700">
            {checkIds.length}
          </span>
        </div>
      </div>
      {openModalShareResponse && (
        <ModalShareAnswers
          onClose={() => setOpenModalShareResponse(false)}
          showDialog={openModalShareResponse}
        />
      )}
    </>
  );
};
